








import { Component, Mixins, Prop } from "vue-property-decorator";

import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

@Component({})

export default class BorderlessTexarea extends Mixins(BaseBorderless) {

    @Prop({ default: 1 }) rows: number;
    @Prop({ default: false }) disabled: boolean;
}
